<mat-card appearance="outlined" class="container-fluid container">
  <mat-card-title class="container-header header_popup">
    <span class="title">Historique des retours PPR</span>
    <div class="align-items-start subheader">
      <hr>
    </div>
  </mat-card-title>
  <mat-card-content class="container-content content">
    <app-invoice-list [(data)]="logsInError" [configKey]="configKey" [canDownload]="false" [exportFileName]="exportFileName" [showClearFilterButton]="true" [showFilter]="false" [pageSize]="5"
      ngDefaultControl>
    </app-invoice-list>
  </mat-card-content>
  <mat-card-footer class="container-footer">
    <div class="modal-footer d-table w-100">
      <div class="d-table-cell tar">
        <button tabindex="-1" mat-stroked-button class="currentBtn" (click)="close();">Fermer</button>
      </div>
    </div>
  </mat-card-footer>
</mat-card>